import {
  createPersistedState
} from "./chunk-WNM3IC4M.mjs";

// src/index.ts
var src_default = createPersistedState();
export {
  createPersistedState,
  src_default as default
};
